export default function SubcontextoContextoHolderService() {
  let value = undefined;

  function get() {
    return value;
  }

  function getObject() {
    return value;
  }

  function put(key, subcontexto) {
    value = subcontexto;
  }

  function remove() {
    value = undefined;
  }

  function getRegion() {
    return '';
  }

  return {
    get: get,
    getObject: getObject,
    put: put,
    getRegion: getRegion,
    remove: remove
  };
}
